export default function toStringArray(items: unknown): Array<string> {
  let results: Array<string> = [];
  if (Array.isArray(items)) {
    for (let item of items) {
      if (typeof item === 'string') {
        results.push(item);
      }
    }
  }
  return results;
}
